'use client';

import Link from 'next/link';
import { useOptionalTranslations } from '@/i18n';

export default function NotFound() {
  // Optional: when notFound() bubbles past the [locale] layout there is no
  // LocaleProvider, so fall back to English rather than crash
  const t = useOptionalTranslations()?.notFound;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white dark:bg-black px-6">
      <h1 className="text-9xl font-display font-bold text-brand-red mb-4">404</h1>
      <h2 className="text-3xl font-serif italic text-black dark:text-white mb-8">
        {t?.title ?? 'Page Not Found'}
      </h2>
      <p className="text-zinc-600 dark:text-zinc-400 mb-8 text-center max-w-md">
        {t?.description ?? "The page you're looking for doesn't exist or has been moved."}
      </p>
      <Link
        href="/"
        className="bg-brand-red text-white px-8 py-4 rounded-full font-bold uppercase text-sm tracking-widest hover:bg-brand-red/90 transition-colors"
      >
        {t?.goHome ?? 'Go Home'}
      </Link>
    </div>
  );
}
